// extracted by mini-css-extract-plugin
export var cardAthlete = "CardAthlete_cardAthlete__Wni7N";
export var imgContainerWrapper = "CardAthlete_imgContainerWrapper__vDUKE";
export var imgAspectRatioContainer = "CardAthlete_imgAspectRatioContainer__1nYyr";
export var img = "CardAthlete_img__POXyz";
export var textName = "CardAthlete_textName__qhTuq";
export var textNftCount = "CardAthlete_textNftCount__0s7FD";
export var rowLegends = "CardAthlete_rowLegends__UT+RH";
export var rotate = "CardAthlete_rotate__luZ05";
export var dotty = "CardAthlete_dotty__-jzIt";